import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const borivali: AreaConfig = {
  name: 'Borivali',
  slug: 'borivali',
  tagline: 'Doorstep Mobile Repair in Borivali, Mumbai',
  description:
    'No need to travel to a repair shop. minto sends a trained technician directly to your home or office in Borivali East or West. Screen, battery, and all phone repairs done on-site.',
  localities: [
    'Borivali East', 'Borivali West', 'IC Colony', 'Shimpoli', 'Mandapeshwar',
    'Eksar', 'Poisar', 'Dahisar East', 'Dahisar West', 'Kandivali East',
    'Kandivali West', 'Charkop', 'Malad West', 'Goregaon East',
  ],
  zones: [
    {
      name: 'Borivali West — IC Colony & Shimpoli',
      line: 'Western Line',
      station: 'Borivali West Station',
      localities: ['IC Colony', 'Shimpoli', 'Mandapeshwar', 'Eksar', 'Poisar', 'Borivali West', 'New Mhada'],
      desc: 'Covering the popular residential localities of Borivali West. Technicians available 7 days a week for doorstep repairs.',
    },
    {
      name: 'Kandivali',
      line: 'Western Line',
      station: 'Kandivali Station',
      localities: ['Kandivali East', 'Kandivali West', 'Charkop', 'Thakur Complex', 'Lokhandwala Township', 'Samata Nagar'],
      desc: 'Kandivali East and West fully covered. We serve Thakur Complex residents, Charkop society members and Lokhandwala Township daily.',
    },
    {
      name: 'Dahisar',
      line: 'Western Line',
      station: 'Dahisar Station',
      localities: ['Dahisar East', 'Dahisar West', 'Anand Nagar', 'Rawalpada', 'Dahisar Check Naka', 'Mira Road adjacent'],
      desc: 'Dahisar is the northernmost zone of our Borivali coverage. Same-day service available for most repairs in Dahisar East and West.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Borivali | Doorstep Phone Repair Service | minto',
    description:
      'Expert doorstep mobile repair in Borivali East & West, Kandivali, Dahisar, Mumbai. Screen replacement, battery repair, charging port fix. 90-day warranty. Starting ₹299. Book now!',
    keywords:
      'mobile repair Borivali, phone repair Borivali, screen repair Borivali, battery replacement Borivali, doorstep mobile repair Borivali, iPhone repair Borivali, Samsung repair Borivali, Kandivali mobile repair, Dahisar phone repair, IC Colony phone repair, Charkop mobile repair',
  },
  faqs: [
    {
      q: 'Do you offer doorstep mobile repair in Borivali East?',
      a: 'Yes, we cover Borivali East including Mandapeshwar, Eksar, and Poisar. Our technicians typically arrive within 60–90 minutes.',
    },
    {
      q: 'Do you also service Kandivali and Dahisar near Borivali?',
      a: 'Yes! Kandivali East, Kandivali West, Dahisar East, and Dahisar West are all part of our Borivali service zone.',
    },
    {
      q: 'How much does screen repair cost in Borivali?',
      a: 'Screen repair starts from ₹999. Choose your device on our booking page to see the exact price before confirming.',
    },
    {
      q: 'Can you repair a Samsung phone in Borivali West?',
      a: 'Yes, we repair all major brands including Samsung, iPhone, OnePlus, Xiaomi, Realme, and more in Borivali West.',
    },
    {
      q: 'Is there a warranty for repairs done in Borivali?',
      a: 'All repairs carry a 90-day warranty. If the same issue reappears within 90 days, we fix it at no extra cost.',
    },
  ],
};

const BorivaliPage: React.FC = () => <AreaLandingPage area={borivali} />;
export default BorivaliPage;
